module.exports = __webpack_public_path__ + "img/pr-15.97d1491d.png";